import React, { useState, useEffect } from 'react';
import '../../QueuePage.scss'

const ReassignHeaderCheckbox = ({ selectAllTickets, headerCheckboxState }) => {
    const [displayStatus, setDisplayStatus] = useState(false);
    const [isIndeterminate, setIsIndeterminate] = useState(false);

    const handleCheckboxClicked = () => {
        setDisplayStatus(!displayStatus);
        selectAllTickets(!displayStatus);
    }

    useEffect(() => {
        setDisplayStatus(headerCheckboxState === 'unchecked' ? false : true)
        setIsIndeterminate(headerCheckboxState === 'indeterminate' ? true : false)
    }, [headerCheckboxState])

    return (
        <input className={isIndeterminate ? 'queue-table-reassign-checkbox-indeterminate' : 'queue-table-reassign-checkbox'} type='checkbox' onChange={handleCheckboxClicked} checked={displayStatus} />
    )
}

export default ReassignHeaderCheckbox